import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Signal,
	signal,
	ViewEncapsulation,
} from '@angular/core';
import { MsBreadcrumsService } from '../../services/ms-breadcrums/ms-breadcrums.services';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { MenuItem } from 'primeng/api';

interface Scope {
	loading: Signal<boolean>;
}

@Component({
	selector: 'ms-breadcrumbs',
	templateUrl: './ms-breadcrumbs.component.html',
	styleUrls: ['./ms-breadcrumbs.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsBreadcrumbsComponent implements OnInit, OnDestroy {
	@Input() items: MenuItem[] | undefined;
	@Input({ required: false }) activatedRoute: ActivatedRoute; //<--TODO: Colocar para true obrigatório

	home: MenuItem | undefined;
	scope: Scope = {
		loading: signal(true),
	};
	private _unsubscribeAll: Subject<any> = new Subject<any>();

	/**
	 * Constructor
	 */
	constructor(private _msBreadcrumsService: MsBreadcrumsService) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		if (!this.items) {
			this._msBreadcrumsService
				.instance()
				.onPageLoad(this.activatedRoute)
				.create()
				.pipe(takeUntil(this._unsubscribeAll))
				.subscribe((data: MenuItem[]) => {
					this.items = data;
				});
		}

		this.home = { icon: 'pi pi-home', routerLink: '/' };
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this._msBreadcrumsService.destroy();
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
